import { withHTMLComponent } from '@updater-legacy/components/custom-element';

const styles = `
  :host {
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    background: currentColor;
    padding: 0.4em;
    width: 1em;
    height: 1em;
    line-height: 1;
    position: relative;
  }


  ::slotted(*) {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }
`;

const html = `
  <slot></slot>
`;

class Circle extends withHTMLComponent(styles, html)() {}

customElements.define('upd-home-security-circle', Circle);
